import { formatInTimeZone } from "date-fns-tz";
import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../common/DetailField";

interface DriverActionsSectionProps {
  booking: BookingDetails;
}

export const DriverActionsSection = ({ booking }: DriverActionsSectionProps) => {
  const { dates } = booking;

  const formatTime = (timestamp: string) => {
    return formatInTimeZone(new Date(timestamp), dates.timezone, "h:mm:ss a");
  };

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField
        leading={<Icon name="UserSquare" size="lg" className="text-neutral-dark-gray" />}
        label="Driver On Route to Pickup"
        value={dates.driverOnWay ? formatTime(dates.driverOnWay) : "-"}
      />

      <DetailField
        leading={<Icon name="User" size="lg" className="text-neutral-dark-gray" />}
        label="Client Picked Up"
        value={dates.clientPickup ? formatTime(dates.clientPickup) : "-"}
      />

      <DetailField
        leading={<Icon name="User" size="lg" className="text-neutral-dark-gray" />}
        label="Client Dropped Off"
        value={dates.clientDroppedOff ? formatTime(dates.clientDroppedOff) : "-"}
      />
    </Card>
  );
};
